import { Fragment, ReactElement } from 'react';
import ResearchFamilyNotificationsDetailCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-family/detail';

const ResearchFamilyNotificationsDetailCivilStatusMotherPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchFamilyNotificationsDetailCivilStatusShared isMother />
    </Fragment>
  );
};

ResearchFamilyNotificationsDetailCivilStatusMotherPage.displayName =
  'Research Family Notifications CivilStatusMotherPage component';

export default ResearchFamilyNotificationsDetailCivilStatusMotherPage;
